module.exports = __webpack_public_path__ + "img/icon_map_63_on_110.13b013e8.png";